import { Resources } from 'constants/resources';

import { useState } from 'react';

import { yupResolver } from '@hookform/resolvers/yup';
import { PRESETS_CREATE_SCHEMA } from 'pages/Presets/schemas/schema';
import { Form, HttpError, RaRecord, useNotify, useRedirect } from 'react-admin';
import { FieldValues } from 'react-hook-form';
import { CreatePage } from 'shared/react-admin/Pages/CreatePage/CreatePage';
import { ErrorData, ErrorDataViolation } from 'types/embedded/error';
import { cleanEmpty } from 'utils/cleanEmpty';

import { PresetsCreateActions } from './PresetsCreateActions';
import { PresetsCreateForm, PresetsCreateFormValues } from './PresetsCreateForm/PresetsCreateForm';

const transform = (data: RaRecord): RaRecord => {
  const {
    paymentItems = [],
    payoutItems = [],
    ...rest
  } = data as PresetsCreateFormValues & RaRecord;
  const presetItems = [
    ...paymentItems.map((item) => cleanEmpty(item)),
    ...payoutItems.map((item) => cleanEmpty(item)),
  ];

  return { ...rest, presetItems };
};

const DEFAULT_VALUES: Partial<PresetsCreateFormValues> = {
  merchant: null,
  gateway: null,
  currency: null,
  paymentComment: null,
  paymentItems: [],
  payoutItems: [],
};

export const PresetsCreate: React.FC = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const [error, setError] = useState<HttpError | null>(null);

  const onSuccess = () => {
    notify('Пресеты успешно созданы', { type: 'info' });
    redirect('list', Resources.Presets);
  };

  const onError = (error: Error) => {
    const httpError = error as HttpError;
    const body = httpError.body as ErrorData | undefined;
    const violations: ErrorDataViolation[] = body?.violations ?? [];

    if (violations.length > 0) {
      const text = violations
        .map(({ propertyPath, message }) =>
          propertyPath ? `${propertyPath}: ${message}` : message,
        )
        .join(' ');
      notify(`Ошибка: ${text}`, {
        type: 'error',
        autoHideDuration: 5000,
      });
    } else {
      notify(`Ошибка: ${httpError.message || 'ошибка сервера'}`, {
        type: 'error',
        autoHideDuration: 3000,
      });
    }
    setError(httpError);
  };

  return (
    <CreatePage
      listName="Пресеты"
      mutationOptions={{ onError, onSuccess }}
      title="Создание пресетов"
      transform={transform}
    >
      <Form
        defaultValues={DEFAULT_VALUES}
        resolver={yupResolver<FieldValues>(PRESETS_CREATE_SCHEMA)}
      >
        <PresetsCreateForm error={error} />
        <PresetsCreateActions />
      </Form>
    </CreatePage>
  );
};
